export default __webpack_public_path__ + "static/collection-1-9316b8b4b36b34040faa10d54f03315e.webp";